import { useState } from 'react';
import { MdVisibility, MdVisibilityOff } from 'react-icons/md';

function PasswordField({
  id,
  name = 'password',
  label = 'Password',
  value,
  onChange,
  autoComplete = 'current-password',
  required = false,
  minLength,
  disabled = false,
  className = 'owner-form-input',
  labelClassName = 'owner-form-label',
}) {
  const [visible, setVisible] = useState(false);

  return (
    <div className="owner-form-group">
      {label && (
        <label className={labelClassName} htmlFor={id}>{label}</label>
      )}
      <div className="auth-password-field">
        <input
          id={id}
          name={name}
          type={visible ? 'text' : 'password'}
          className={`${className} auth-password-input`}
          value={value}
          onChange={onChange}
          autoComplete={autoComplete}
          required={required}
          minLength={minLength}
          disabled={disabled}
        />
        <button
          type="button"
          className="auth-password-toggle"
          onClick={() => setVisible((v) => !v)}
          aria-label={visible ? 'Hide password' : 'Show password'}
          title={visible ? 'Hide password' : 'Show password'}
          tabIndex={0}
          disabled={disabled}
        >
          {visible ? <MdVisibilityOff /> : <MdVisibility />}
        </button>
      </div>
    </div>
  );
}

export default PasswordField;
